import { useEffect } from "react";

export default function ChamUpload() {

    useEffect(() => {
        document.querySelector("im-upload").addEventListener("upload", function () {
            if(document.getElementById("imgInp").value !== ""){
                document.querySelector("dialog").showModal();
            } 
          });
          
          document.getElementById('imgToUpload').addEventListener('load', function(){ // Goes straight to visualizer
            document.querySelector('#upload-section .btn-upload').click();
          });
    

    }, []);

    return(
        <im-upload title="Upload My Own Photo" calltoaction="Start Your Project" active="0" postpage="IM.aspx"></im-upload>
    );
}

export function ChamUploadButton({className, title}) {

    const handleClick = function() {
        document.querySelector(".uploaderBTN").click()
    }

    return(
        <button onClick={handleClick} className={className}>{title}</button>
    )
}